export const VERSE_BARS_STATUS_DEFAULTS = {
    verseBarsStatus: 0,
}

export const VERSE_BARS_DEFAULTS = {
    ...VERSE_BARS_STATUS_DEFAULTS,
}
